import { render, staticRenderFns } from "./signNum.vue?vue&type=template&id=b81ef7d2&scoped=true&"
import script from "./signNum.vue?vue&type=script&lang=js&"
export * from "./signNum.vue?vue&type=script&lang=js&"
import style0 from "./signNum.vue?vue&type=style&index=0&id=b81ef7d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ef7d2",
  null
  
)

export default component.exports